// roots/resources/assets/scripts/main.js

/**
 * ---------------------------------------------------------
 * GLOBAL STYLES
 * ---------------------------------------------------------
 */

// import '../styles/main.scss';

/**
 * ---------------------------------------------------------
 * GLOBAL JQUERY BRIDGE
 * ---------------------------------------------------------
 */

if (typeof window.jQuery !== 'undefined') {
  window.$ = window.jQuery;
  // window.jQuery = window.jQuery;
}

/**
 * ---------------------------------------------------------
 * SHARED VENDOR LOADERS
 * ---------------------------------------------------------
 */

const sharedLoaders = {
  flickity: null,
  modal: null,
  collapse: null,
  select2: null,
};

/**
 * ---------------------------------------------------------
 * HELPERS
 * ---------------------------------------------------------
 */

export function hasElement(selector) {
  return document.querySelector(selector) !== null;
}

/**
 * ---------------------------------------------------------
 * BOOTSTRAP MODAL
 * ---------------------------------------------------------
 */

export async function ensureModal() {
  if (!sharedLoaders.modal) {
    sharedLoaders.modal = import('bootstrap/js/dist/modal').then((module) => {
      window.bootstrap = {
        ...(window.bootstrap || {}),
        Modal: module.default,
      };

      return module;
    });
  }

  return sharedLoaders.modal;
}

/**
 * ---------------------------------------------------------
 * BOOTSTRAP COLLAPSE
 * ---------------------------------------------------------
 */

export async function ensureCollapse() {
  if (!sharedLoaders.collapse) {
    sharedLoaders.collapse = import('bootstrap/js/dist/collapse');
  }

  return sharedLoaders.collapse;
}

/**
 * ---------------------------------------------------------
 * FLICKITY
 * ---------------------------------------------------------
 */

export async function ensureFlickity() {
  if (window.$ && $.fn.flickity) {
    return;
  }

  if (!sharedLoaders.flickity) {
    sharedLoaders.flickity = Promise.all([
      import('flickity'),
      import('flickity-fade'),
    ]).then(([flickityModule]) => {
      const Flickity = flickityModule.default;

      window.Flickity = Flickity;

      if (window.$ && !$.fn.flickity) {
        $.fn.flickity = function (arg, ...args) {
          return this.each(function () {
            let instance = this._flickity;

            if (!instance) {
              instance = new Flickity(
                this,
                typeof arg === 'object' ? arg : {}
              );

              this._flickity = instance;
            }

            if (
              typeof arg === 'string' &&
              typeof instance[arg] === 'function'
            ) {
              instance[arg](...args);
            }
          });
        };
      }
    });
  }

  return sharedLoaders.flickity;
}

/**
 * ---------------------------------------------------------
 * SELECT2
 * ---------------------------------------------------------
 */

export async function ensureSelect2() {
  if (window.$ && $.fn.select2) {
    return;
  }

  if (!sharedLoaders.select2) {
    sharedLoaders.select2 = import('select2').then((module) => {
      if (window.$ && !$.fn.select2) {
        module.default(window.$);
      }
    });
  }

  return sharedLoaders.select2;
}